import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { PermissionService } from './permission.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';

@Injectable({
  providedIn: 'root',
})
export class LicenseExpiredGuardService  {
  constructor(
    public auth: AuthenticationService, 
    public permission:PermissionService,
    public router: Router, private util: UtilServiceService) {}

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    let isLicenseExpiredUser: boolean = this.util.getLicenseExpiryStatus();
    if (isLicenseExpiredUser === true){
      console.log('your license is expired - canActivate!')
        this.router.navigateByUrl("/dashboard/setup/licenseBilling");
        return false;
    }
    else{
        return true;
    }
  }

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {

    let isLicenseExpiredUser: boolean = this.util.getLicenseExpiryStatus();
    console.log(isLicenseExpiredUser, 'isLicenseExpiredUser printing in license expired guard')

    if (isLicenseExpiredUser === true){
        //this.router.navigateByUrl("/dashboard/error");
        console.log('your license is expired!')
        this.router.navigateByUrl('/dashboard/setup/licenseBilling');
        return false;
    }
    else{
        return true;
    }

  }

  

}